import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const positionImporterSelectors = importerSelectors(
  'position.importer',
);

export default positionImporterSelectors;
